export default __webpack_public_path__ + "img/footer-1db1740c.png";